import {
  Label,
  PolarGrid,
  PolarRadiusAxis,
  RadialBar,
  RadialBarChart,
} from "recharts"

import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "./Card"
import { ChartContainer } from "./Chart"

export default function RadialChart({ percentage }) {

  const getColor = (percent) => {
    if (percent < 20) return "#ef4444" 
    if (percent < 50) return "#f59e0b" 
    return "#10b981"
  }

  const chartColor = getColor(percentage)
  
  const chartData = [
    { 
      name: "percentage", 
      value: percentage, 
      fill: chartColor 
    }
  ]

  const chartConfig = {
    percentage: {
      label: "Percentage",
    },
  }

  const startAngle = 180
  const endAngle = 180 + (percentage * -360 / 100)

  return (
    <Card className="flex flex-col py-0 gap-0 shadow-none border-none">
      <CardHeader className="items-center pb-0">
      </CardHeader>
      <CardContent className="flex-1 pb-0">
        <ChartContainer
          config={chartConfig}
          className="mx-auto aspect-square"
        >
          <RadialBarChart
            data={chartData}
            startAngle={startAngle}
            endAngle={endAngle}
            innerRadius={60}
            outerRadius={80}
          >
            <PolarGrid
              gridType="circle"
              radialLines={false}
              stroke="none"
              className="first:fill-muted last:fill-background"
              polarRadius={[66, 54]}
            />
            <RadialBar 
              dataKey="value" 
              background 
              cornerRadius={10}
            />
            <PolarRadiusAxis tick={false} tickLine={false} axisLine={false}>
              <Label
                content={({ viewBox }) => {
                  if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                    return (
                      <text
                        x={viewBox.cx}
                        y={viewBox.cy}
                        textAnchor="middle"
                        dominantBaseline="middle"
                      >
                        <tspan
                          x={viewBox.cx}
                          y={viewBox.cy}
                          className="font-bold text-2xl"
                          style={{ fill: chartColor }}
                        >
                          {percentage}%
                        </tspan>
                        <tspan
                          x={viewBox.cx}
                          y={(viewBox.cy || 0) + 18}
                          className="fill-muted-foreground text-xs"
                        >
                          sur 100%
                        </tspan>
                      </text>
                    )
                  }
                }}
              />
            </PolarRadiusAxis>
          </RadialBarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  )
}
